import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification';
import VueMoment from 'vue-moment'
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
import locale from 'element-ui/lib/locale/lang/en'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import CKEditor from 'ckeditor4-vue';
import VueMeta from 'vue-meta'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(ElementUI, { locale })

Vue.use( CKEditor );

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.prototype.$pageMeta = function($meta) {
  return _.get(store.getters['getInit'], 'client.title');
}

Vue.filter('toDouble', function (value) {
  value = parseFloat(value).toFixed(2);
  return isNaN(value) ? 0 : value;
});

Vue.prototype.$permission = function (permission) {
  return store.getters['auth/permission'](permission)
}

window.axios = require('axios');
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL; 
window.axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Authorization': 'Bearer ' +  store.getters['auth/token'],
  'X-Requested-With': 'XMLHttpRequest',
  //'Client': window.location.host,
  'Client': 'demo.e-tahsilat.io',
};

window.axios.interceptors.response.use((response) => {
  return response
},
function (error) {
  if (error.response.status === 401) {
    store.dispatch('alert/alert', { type: 'error', title: error.response.data.message})
    store.dispatch('auth/logout', { silent: true })
  } else if (error.response.status === 422 || error.response.status === 429 || error.response.status === 403) {
    store.dispatch('alert/alert', { type: 'error', errors: error.response.data.errors, title: error.response.data.message });
  } else{
    store.dispatch('alert/alert', { type: 'error', title: 'whoops' });
  }
  return Promise.reject(error);
});

Vue.use(Notifications);
Vue.use(VueMoment);

window._ = require("lodash");
Vue.prototype._ = window._;

import './assets/scss/app.scss'

Vue.prototype.$user = function() {
  return store.getters['auth/user'];
}
Vue.prototype.$user_detail = function() {
    return store.getters['auth/user_detail'];
}
Vue.prototype.$auth = function() {
  return store.getters['auth/isLoggedIn'];
}

// MOBILE DETECT
import { isMobile } from 'mobile-device-detect';
Vue.prototype.isMobile = isMobile

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
